import get from "lodash/get";
import React, { useEffect, useMemo, useState } from "react";
import { Button, PlusIcon } from "@pd/pd-ui-kit";
import { Flex } from "antd";
import { useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import TableReducer from "~/pages/Editor/EditorServiceAuthorization/TableReducer";
import Wrapper from "~/shared/ui/Wrapper";
import { LANG } from "~/constans/commom";
import { useSetLocationData } from "~/hooks/locationData";
import {
  SUB_OPTIONS,
  TABLE_REDUCER_OPTIONS,
  TABLE_REDUCER_OPTIONS_PERIOD,
} from "~/pages/Editor/EditorServiceAuthorization/TableReducer/options";
import {
  useGetAllNotesQuery,
  useGetAllPersonalQuery,
  useGetAllPlacePostsQuery,
  useGetAllPlacesQuery,
  useGetAllRequiredToolsQuery,
  useGetAllServicesQuery,
  useGetAllToolsInsuranceParentQuery,
  useGetAllToolsInsuranceQuery,
  useGetAllToolsMetrologicalQuery,
  useGetAllToolsParentQuery,
  useGetAllToolsQuery,
  useGetAllTradePremisesQuery,
  useGetAllWarehousesQuery,
  useGetGroupsToolsInsuranceQuery,
  useGetGroupsToolsQuery,
  useSetBlindChangeNotesMutation,
  useSetBlindChangePersonalMutation,
  useSetBlindChangePlacePostsMutation,
  useSetBlindChangePlacesMutation,
  useSetBlindChangeRequiredToolsMutation,
  useSetBlindChangeSerivceMutation,
  useSetBlindChangeToolsInsuranceMutation,
  useSetBlindChangeToolsMetrologicalMutation,
  useSetBlindChangeToolsMutation,
  useSetBlindChangeTradePremisesMutation,
  useSetBlindChangeWarehousesMutation,
  useSetChangeNotesMutation,
  useSetChangePersonalMutation,
  useSetChangePlacePostsMutation,
  useSetChangePlacesMutation,
  useSetChangeRequiredToolsMutation,
  useSetChangeSerivceMutation,
  useSetChangeToolsInsuranceMutation,
  useSetChangeToolsMetrologicalMutation,
  useSetChangeToolsMutation,
  useSetChangeTradePremisesMutation,
  useSetChangeWarehousesMutation,
  useSetCreateNotesMutation,
  useSetCreatePersonalMutation,
  useSetCreatePlacePostsMutation,
  useSetCreatePlacesMutation,
  useSetCreateRequiredToolsMutation,
  useSetCreateSerivceMutation,
  useSetCreateToolsInsuranceMutation,
  useSetCreateToolsMetrologicalMutation,
  useSetCreateToolsMutation,
  useSetCreateTradePremisesMutation,
  useSetCreateWarehousesMutation,
  useSetDeleteNotesMutation,
  useSetDeletePersonalMutation,
  useSetDeletePlacePostsMutation,
  useSetDeletePlacesMutation,
  useSetDeleteRequiredToolsMutation,
  useSetDeleteSerivceMutation,
  useSetDeleteToolsInsuranceMutation,
  useSetDeleteToolsMetrologicalMutation,
  useSetDeleteToolsMutation,
  useSetDeleteTradePremisesMutation,
  useSetDeleteWarehousesMutation,
  ZdGroupType,
} from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";
import { Field } from "~/shared/ui/Field";

import { FACTORY_OPTION } from "./options";

import s from "./style.less";

const EditorServiceAuthorization = () => {
  const { t } = useTranslation();
  const isEn = localStorage.getItem("language") === LANG.en;
  const noCaching = sessionStorage.getItem("noCaching");
  const setData = useSetLocationData(true);
  const history = useHistory();
  const { hasPermission } = usePermissions();
  const goBack = () => {
    history.replace("/editor/");
  };
  const { control, watch } = useForm({
    defaultValues: {
      editorSelect: {
        label: ` ${t("editorZD.forSelect.services")}`,
        value: "services",
      },
    },
  });

  const toolsGroup = useGetGroupsToolsQuery({
    variables: {
      groupType: ZdGroupType.GroupOne,
    },
    fetchPolicy: "cache-and-network",
  });

  const toolsInsuranceGroup = useGetGroupsToolsInsuranceQuery({
    variables: {
      groupType: ZdGroupType.GroupOne,
    },
    fetchPolicy: "cache-and-network",
  });

  const arrToolsGroup = get(toolsGroup, "data.ToolsGetter.getGroups", []);
  const arrToolsInsuranceGroup = get(
    toolsInsuranceGroup,
    "data.ToolsInsuranceGetter.getGroups",
    [],
  );

  const selectedService = watch("editorSelect").value;
  const editorModel = TABLE_REDUCER_OPTIONS[selectedService];
  const periodModel = TABLE_REDUCER_OPTIONS_PERIOD[selectedService];

  useEffect(() => {
    setData("page", 0);
  }, [selectedService]);

  const options = SUB_OPTIONS[selectedService];
  //requests
  const requests = {
    services:
      selectedService === "services" &&
      useGetAllServicesQuery({
        fetchPolicy: "cache-and-network",
      }),
    requiredTools:
      selectedService === "requiredTools" &&
      useGetAllRequiredToolsQuery({
        fetchPolicy: "cache-and-network",
      }),
    toolsInsurance:
      selectedService === "toolsInsurance" &&
      useGetAllToolsInsuranceQuery({
        fetchPolicy: "cache-and-network",
      }),
    toolsMetrological:
      selectedService === "toolsMetrological" &&
      useGetAllToolsMetrologicalQuery({
        fetchPolicy: "cache-and-network",
      }),
    warehouses:
      selectedService === "warehouses" &&
      useGetAllWarehousesQuery({
        fetchPolicy: "cache-and-network",
      }),
    tools:
      selectedService === "tools" &&
      useGetAllToolsQuery({
        fetchPolicy: "no-cache",
      }),
    places:
      selectedService === "places" &&
      useGetAllPlacesQuery({
        fetchPolicy: "cache-and-network",
      }),
    placePosts:
      selectedService === "placePosts" &&
      useGetAllPlacePostsQuery({
        fetchPolicy: "cache-and-network",
      }),
    personal:
      selectedService === "personal" &&
      useGetAllPersonalQuery({
        fetchPolicy: "cache-and-network",
      }),
    notes:
      selectedService === "notes" &&
      useGetAllNotesQuery({
        fetchPolicy: "cache-and-network",
      }),
    tradePremises:
      selectedService === "tradePremises" &&
      useGetAllTradePremisesQuery({
        fetchPolicy: "cache-and-network",
      }),
  };

  const { loading, items, refetch } = getItems(selectedService);

  function getItems(selectedService) {
    const getterStr =
      selectedService[0].toUpperCase() + selectedService.substr(1) + "Getter";
    return (
      requests[selectedService] && {
        loading: requests[selectedService].loading,
        items: get(requests[selectedService].data, `${getterStr}.getAll`, []),
        refetch: requests[selectedService].refetch,
      }
    );
  }

  const places = useGetAllPlacesQuery({
    fetchPolicy: noCaching ? "cache-and-network" : "cache-first",
  });

  const selectPlaces = get(places, "data.PlacesGetter.getAll", []).map(
    ({ id, Name, NameEn }) => ({
      value: id,
      label: isEn ? NameEn || Name : Name || NameEn,
    }),
  );

  const toolsParent = useGetAllToolsParentQuery({
    fetchPolicy: "no-cache",
  });

  const toolsParentWrite = get(toolsParent, "data.ToolsGetter.getAll", []);

  const toolsInsuranceParent = useGetAllToolsInsuranceParentQuery({
    fetchPolicy: "no-cache",
  });

  const toolsInsuranceParentWrite = get(
    toolsInsuranceParent,
    "data.ToolsInsuranceGetter.getAll",
    [],
  );

  const mutation = {
    services: selectedService === "services" && {
      create: useSetCreateSerivceMutation,
      change: useSetChangeSerivceMutation,
      blind: useSetBlindChangeSerivceMutation,
      deleteMut: useSetDeleteSerivceMutation,
    },
    requiredTools: selectedService === "requiredTools" && {
      create: useSetCreateRequiredToolsMutation,
      change: useSetChangeRequiredToolsMutation,
      blind: useSetBlindChangeRequiredToolsMutation,
      deleteMut: useSetDeleteRequiredToolsMutation,
    },
    toolsInsurance: selectedService === "toolsInsurance" && {
      create: useSetCreateToolsInsuranceMutation,
      change: useSetChangeToolsInsuranceMutation,
      blind: useSetBlindChangeToolsInsuranceMutation,
      deleteMut: useSetDeleteToolsInsuranceMutation,
    },
    toolsMetrological: selectedService === "toolsMetrological" && {
      create: useSetCreateToolsMetrologicalMutation,
      change: useSetChangeToolsMetrologicalMutation,
      blind: useSetBlindChangeToolsMetrologicalMutation,
      deleteMut: useSetDeleteToolsMetrologicalMutation,
    },
    tools: selectedService === "tools" && {
      create: useSetCreateToolsMutation,
      change: useSetChangeToolsMutation,
      blind: useSetBlindChangeToolsMutation,
      deleteMut: useSetDeleteToolsMutation,
    },
    warehouses: selectedService === "warehouses" && {
      create: useSetCreateWarehousesMutation,
      change: useSetChangeWarehousesMutation,
      blind: useSetBlindChangeWarehousesMutation,
      deleteMut: useSetDeleteWarehousesMutation,
    },
    places: selectedService === "places" && {
      create: useSetCreatePlacesMutation,
      change: useSetChangePlacesMutation,
      blind: useSetBlindChangePlacesMutation,
      deleteMut: useSetDeletePlacesMutation,
    },
    placePosts: selectedService === "placePosts" && {
      create: useSetCreatePlacePostsMutation,
      change: useSetChangePlacePostsMutation,
      blind: useSetBlindChangePlacePostsMutation,
      deleteMut: useSetDeletePlacePostsMutation,
    },
    personal: selectedService === "personal" && {
      create: useSetCreatePersonalMutation,
      change: useSetChangePersonalMutation,
      blind: useSetBlindChangePersonalMutation,
      deleteMut: useSetDeletePersonalMutation,
    },
    notes: selectedService === "notes" && {
      create: useSetCreateNotesMutation,
      change: useSetChangeNotesMutation,
      blind: useSetBlindChangeNotesMutation,
      deleteMut: useSetDeleteNotesMutation,
    },
    tradePremises: selectedService === "tradePremises" && {
      create: useSetCreateTradePremisesMutation,
      change: useSetChangeTradePremisesMutation,
      blind: useSetBlindChangeTradePremisesMutation,
      deleteMut: useSetDeleteTradePremisesMutation,
    },
  };

  const { create, change, blind, deleteMut } = mutation[selectedService];

  const openAddModal = () => {
    setData("openModal", "Add");
  };

  const filteredFactoryOptions = useMemo(() => {
    return FACTORY_OPTION.filter((el) => el !== "personal");
  }, []);

  const editorSelectOptions = useMemo(
    () =>
      filteredFactoryOptions.map((option) => ({
        label: t(`editorZD.forSelect.${option}`),
        value: option,
      })),
    [filteredFactoryOptions, t],
  );

  return (
    <Wrapper.Content
      title={t("editor.zd")}
      goBackHandler={goBack}
      txtBtn={t("ui.back")}
      controlComponent={
        <Flex gap={10}>
          <Field
            type="select"
            name="editorSelect"
            control={control}
            options={editorSelectOptions}
            labelInValue
            wrapperClassName={s.selectEditor}
          />
          {hasPermission("zd.create") && (
            <Button
              onClick={openAddModal}
              size={"medium"}
              icon={<PlusIcon size={16} />}
            >
              {t("ui.add")}
            </Button>
          )}
        </Flex>
      }
    >
      <TableReducer
        {...{
          selectedService,
          editorModel,
          periodModel,
          options,
          items,
          toolsInsuranceParentWrite,
          arrToolsGroup,
          arrToolsInsuranceGroup,
          toolsParentWrite,
          loading,
          refetch,
          create,
          change,
          blind,
          deleteMut,
        }}
        selectPlaces={
          selectedService === "placePosts" ? selectPlaces : undefined
        }
        refetchToolsGroup={toolsGroup.refetch}
        refetchToolsInsuranceGroup={toolsInsuranceGroup.refetch}
        refetchParrentTools={toolsParent.refetch}
        refetchParrentToolsInsurance={toolsInsuranceParent.refetch}
      />
    </Wrapper.Content>
  );
};
export default EditorServiceAuthorization;
